import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '..';

export const selectSelf = (state: RootState) => state.user;

export const selectAccessToken = createSelector(
  selectSelf,
  ({ accessToken }) => accessToken
);

export const selectRefreshToken = createSelector(
  selectSelf,
  ({ refreshToken }) => refreshToken
);
